export default __webpack_public_path__ + "static/media/06.f528ab04.jpg";